import { render, staticRenderFns } from "./FormateurCard.vue?vue&type=template&id=32b04e01&"
import script from "./FormateurCard.vue?vue&type=script&lang=js&"
export * from "./FormateurCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports